import type { WorkerMissionStatus } from '@/types/mission';

// Workers count per status of a missions list row (propositions and confirmed columns).

export interface WorkersSelectionCount {
	workerStatus: WorkerMissionStatus;
	quantity: number;
}

export const getWorkersSelectionQuantity = (
	selection: WorkersSelectionCount[],
	status: WorkerMissionStatus
): number =>
	selection.find((entry) => entry.workerStatus === status)?.quantity ?? 0;

/** Moves one worker between statuses, dropping the statuses left empty. */
export const shiftWorkersSelection = (
	selection: WorkersSelectionCount[],
	from: WorkerMissionStatus | null,
	to: WorkerMissionStatus
): WorkersSelectionCount[] => {
	const quantities = new Map(
		selection.map((entry) => [entry.workerStatus, entry.quantity])
	);
	if (from) quantities.set(from, Math.max(0, (quantities.get(from) ?? 0) - 1));
	quantities.set(to, (quantities.get(to) ?? 0) + 1);
	return [...quantities]
		.filter(([, quantity]) => quantity > 0)
		.map(([workerStatus, quantity]) => ({ workerStatus, quantity }));
};

export const isSameWorkersSelection = (
	a: WorkersSelectionCount[],
	b: WorkersSelectionCount[]
): boolean => {
	const nonEmptyA = a.filter((entry) => entry.quantity > 0);
	return (
		nonEmptyA.length === b.filter((entry) => entry.quantity > 0).length &&
		nonEmptyA.every(
			(entry) =>
				getWorkersSelectionQuantity(b, entry.workerStatus) === entry.quantity
		)
	);
};
